import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  height: '100%',
  width: '100%',
  gap: (p) => p.spacing(1),
};

export const card: SxStyle = {
  backgroundColor: (p) => p.palette.grey[50],
};

export const cardContent: SxStyle = {
  '&.MuiCardContent-root:last-child': { paddingBottom: 1.5 },
};
